<template>
  <v-row
    class="pt-2 pl-1"
  >
    <v-col
      cols="12"
      sm="5"
    >
      <div class="d-flex justify-center title font-weight-light">
        Configuração da árvore: {{ nomeArvore }}
      </div>

      <v-btn
        class="px-4 mb-2"
        @click="criarNode"
      >
        <v-icon>
          {{ icons.mdiPlus }}
        </v-icon>
        <span>Criar Seção</span>
      </v-btn>

      <v-treeview
        :items="items"
        item-key="id"
        item-text="texto"
        item-children="nosFilhos"
        transition
        :open.sync="open"
        activatable
        :active.sync="activeItems"
        @update:active="handleActiveUpdate"
      >
        <template
          #append="{ item }"
        >
          <v-tooltip
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                dense
                class="cursor-pointer"
                v-on="on"
                @click="handleNode(item)"
              >
                {{ icons.mdiCogOutline }}
              </v-icon>
            </template>
            <span>Configurar nó</span>
          </v-tooltip>

          <v-tooltip
            top
            color="primary"
          >
            <template #activator="{ on, attrs }">
              <v-icon
                v-if="item.nosFilhos.length <= 0"
                dense
                v-bind="attrs"
                class="cursor-pointer ml-2"
                v-on="on"
                @click="handleDelete(item)"
              >
                {{ icons.mdiTrashCanOutline }}
              </v-icon>
            </template>
            <span>Apagar nó</span>
          </v-tooltip>
        </template>

        <template #label="{ item }">
          <div class="d-flex">
            <span
              v-if="item.texto"
              class="text-truncate"
            >
              {{ item.numero }} - {{ item.texto }}
            </span>

            <span
              v-if="item.botaoOpcaoTitle"
              class="text-truncate"
            >
              {{ item.numero }} - {{ item.botaoOpcaoTitle }}
            </span>

            <span
              v-if="item.listaOpcaoTitle"
              class="text-truncate"
            >
              {{ item.numero }} - {{ item.listaOpcaoTitle }}
            </span>

            <v-tooltip
              top
              color="primary"
            >
              <template #activator="{ on, attrs }">
                <v-icon
                  v-if="nodePodeAdicionarFilhos(item)"
                  dense
                  class="cursor-pointer"
                  v-bind="attrs"
                  v-on="on"
                  @click="criarPasta(item)"
                >
                  {{ icons.mdiPlus }}
                </v-icon>
              </template>

              <span>{{ item.nosFilhos.length > 0 ? 'Criar uma opção' : 'Criar uma seção' }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-treeview>
    </v-col>

    <v-divider :vertical="$vuetify.breakpoint.name === 'xs' ? false : true"></v-divider>

    <v-col
      ref="configComponentRef"
      cols="12"
      sm="7"
    >
      <v-scroll-y-transition mode="out-in">
        <div
          v-if="!selected"
          class="d-flex justify-center title font-weight-light"
        >
          Selecione uma opção
        </div>
        <div
          v-else
          class="d-flex justify-center title font-weight-light"
        >
          Personalização da opção
        </div>
      </v-scroll-y-transition>

      <v-scroll-y-transition mode="out-in">
        <div v-if="!selected"></div>

        <arvore-node-config
          v-else
          :node-selecionado="node"
          :chat-bot-id="chatBotId"
          :arvore-id="arvoreId"
          :tipo-id-pai="nodeTipoIdPai"
          :is-arvore-escolhida-pesquisa-satisfacao="isArvoreEscolhidaPesquisaSatisfacao"
          @node-alterado="nodeConfig"
          @success-endpoint="unhandledNode"
          @cancelar-handle="unhandledNode"
        />
      </v-scroll-y-transition>
    </v-col>

    <sair-do-no-dialog
      :mudar-de-ticket.sync="treeConfig"
      @mudar-node="unhandledNode"
    />
  </v-row>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiCogOutline, mdiTrashCanOutline, mdiPlus } from '@mdi/js'
import { required, select } from '@/@core/utils/validation'
import SairDoNoDialog from '../dialogs/SairDoNoDialog.vue'
import NoChatBotModel from '@/models/entities/chat-bot/NodeChatBotModel'
import ArvoreNodeConfig from './ArvoreNodeConfig.vue'
import TipoNoChatBotEnum from '@/models/entities/chat-bot/TipoNoChatBotEnum'
import ChatBotService from '@/services/modules/ChatBotService'
import { EventBus } from '@/utils/EventBus'

export default {
  components: {
    SairDoNoDialog,
    ArvoreNodeConfig,
  },

  props: {
    chatBotId: {
      type: Number,
      default: null,
      required: true,
    },
    arvoreId: {
      type: Number,
      default: null,
      required: false,
    },
    isArvoreEscolhidaPesquisaSatisfacao: Boolean,
  },

  data() {
    return {
      selected: false,
      node: [],
      active: [],
      loading: false,
      treeConfig: false,
      noAlterado: false,
      open: [],
      activeItems: [],
      items: [],
      arvores: [],
      arvoreData: {},
      arvoreAtiva: 0,
      nodeTipoIdPai: null,
    }
  },

  watch: {
    successCrud() {
      if (this.successCrud) {
        this.unhandledNode()
        this.$emit('update:success-crud', false)
      }
    },

    errorCrud() {
      if (this.errorCrud) {
        this.loading = false
        this.$emit('update:error-crud', false)
      }
    },

    async arvoreId() {
      if (this.arvoreId) await this.unhandledNode()
    },
  },

  mounted() {
    this.getNodes()
  },

  methods: {
    async getNodes() {
      this.items = []
      if (!this.arvoreId) return
      try {
        const resGetNode = await ChatBotService.getArvoreNos(this.chatBotId, this.arvoreId)
        const newNode = new NoChatBotModel()
        if (resGetNode.length > 0) {
          this.items = resGetNode
        } else {
          this.items.push({
            ...newNode,
          })

          this.handleNode(this.items[0])
        }
      } catch {
        const newNode = new NoChatBotModel()
        this.items.push({
          ...newNode,
        })

        this.handleNode(this.items[0])
      }
    },

    nodeConfig() {
      this.noAlterado = true
    },

    verificarSeNodePodeTerFilho(element) {
      if (element.chatBotNoTipoId === 2) {
        this.$toast.warning('Não pode criar seções no tipo Fila.')

        return false
      }

      if (element.chatBotNoTipoId === 7 && element.nosFilhos.length === 3) {
        this.$toast.warning('Não pode criar mais de 3 seções no tipo Botão.')

        return false
      }

      if (element.chatBotNoTipoId === 8 && element.nosFilhos.length === 10) {
        this.$toast.warning('Não pode criar mais de 3 seções no tipo Botão.')

        return false
      }

      return true
    },

    criarPasta(element) {
      if (!this.handleClick()) return
      if (!this.verificarSeNodePodeTerFilho(element)) return

      const newNode = new NoChatBotModel()
      element.nosFilhos.push({
        ...newNode,
        noPaiId: element.id,
      })
      this.handleNode(element.nosFilhos.at(-1))
      this.open.push(element.id)
      this.nodeTipoIdPai = element.chatBotNoTipoId
      this.$emit('tipo-id-pai', this.nodeTipoIdPai)
      this.nodeConfig()
    },

    criarNode() {
      if (!this.handleClick()) return

      const newNode = new NoChatBotModel()
      this.items.push({
        ...newNode,
      })
      this.handleNode(this.items.at(-1))
      this.nodeConfig()
    },

    handleActiveUpdate(item) {
      this.activeItems = item
    },

    handleClick() {
      if (this.noAlterado) {
        this.treeConfig = true
        return false
      }
      return true
    },

    async handleDelete(element) {
      if (!this.handleClick()) return

      const request = element.id
      try {
        await ChatBotService.deletarArvoreNo(this.chatBotId, this.arvoreId, request)
        await this.getNodes()
        this.unhandledNode()
      } catch {
        this.unhandledNode()
      }
    },

    async findTipoIdPai(data, id) {
      let nodePai = {}
      // eslint-disable-next-line no-restricted-syntax
      for (const objeto of data) {
        if (objeto.id === id) {
          nodePai = objeto // Retorna o objeto com o ID desejado
          this.nodeTipoIdPai = nodePai.chatBotNoTipoId

          return this.nodeTipoIdPai
        }

        if (objeto.nosFilhos && objeto.nosFilhos.length > 0) {
          // eslint-disable-next-line no-await-in-loop
          const encontradoNosFilhos = await this.findTipoIdPai(objeto.nosFilhos, id)
          if (encontradoNosFilhos) {
            // Retorna o objeto encontrado nos filhos
            this.nodeTipoIdPai = encontradoNosFilhos

            return this.nodeTipoIdPai
          }
        }
      }

      // this.$emit('tipo-id-pai', this.nodeTipoIdPai)
      this.nodeTipoIdPai = nodePai.chatBotNoTipoId

      return this.nodeTipoIdPai
    },

    async handleNode(element) {
      if (!this.handleClick()) return
      this.scrollToTopComponent()
      this.selected = true
      this.node = element
      this.$emit('tipo-id-pai',
        await this.findTipoIdPai(this.items, element.noPaiId))
      this.$emit('node-selecionado', element)
    },

    async unhandledNode() {
      this.node = []
      this.selected = false
      this.treeConfig = false
      this.noAlterado = false
      this.loading = false
      await this.getNodes()
    },

    async getArvoreId(element) {
      if (!this.handleClick()) return
      this.arvoreId = element
      this.unhandledNode()
    },

  },

  setup() {
    const configComponentRef = ref(null)

    const scrollToTopComponent = () => {
      configComponentRef.value.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    }

    const nomeArvore = ref('Principal')

    EventBus.$on('nome-arvore', nome => {
      nomeArvore.value = nome
    })

    function nodePodeAdicionarFilhos(item) {
      return item.noPaiId === null || item.chatBotNoTipoId !== TipoNoChatBotEnum.NotaPesquisa.id
    }

    return {
      configComponentRef,
      nomeArvore,
      scrollToTopComponent,

      nodePodeAdicionarFilhos,

      // Icons
      icons: {
        mdiCogOutline,
        mdiTrashCanOutline,
        mdiPlus,
      },
      validators: {
        required,
        select,
      },
    }
  },
}
</script>

<style lang="scss">
.chat-ativo {
  background: linear-gradient(98deg, #d4d4d468, var(--v-primary-base) 0%);
}
</style>
